import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=edaefd2a"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=js"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports